module.exports = __webpack_public_path__ + "img/plan-3-4.1afecae4.png";